<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Sign In</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <form #f="ngForm" (ngSubmit)="onSubmit(f)" class="ion-padding">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-img
            class="logo"
            src="../../../assets/images/MimboLogo.png"
          ></ion-img>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-list>
            <ion-item color="lightmimbo">
              <ion-label position="floating">E-Mail/Username</ion-label>
              <ion-input
                type="text"
                name="email"
                ngModel
                required
                #emailCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item
              *ngIf="!emailCtrl.valid && emailCtrl.touched"
              lines="none"
              color="lightmimbo"
            >
              <ion-text color="danger"
                ><small>Enter your email/username.</small></ion-text
              >
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input
                type="password"
                name="password"
                label="Password"
                labelPlacement="floating"
                ngModel
                required
                #passwordCtrl="ngModel"
              ></ion-input>
            </ion-item>
            <ion-item
              *ngIf="!passwordCtrl.valid && passwordCtrl.touched"
              lines="none"
              color="lightmimbo"
            >
              <ion-text color="danger"
                ><small>Enter your password.</small></ion-text
              >
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          sizeMd="10"
          offsetMd="1"
          sizeXl="6"
          offsetXl="3"
          class="ion-text-center"
        >
          <ion-button
            color="primary"
            type="submit"
            [disabled]="!f.valid"
            class="signin-btn"
            >Sign In <ion-icon slot="start" name="log-in-outline"></ion-icon
          ></ion-button>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text
            color="primary"
            (click)="goToChangePassword()"
            class="forgot-password link"
            >Forgot Password?</ion-text
          >
        </ion-col>
      </ion-row>
      <ion-row class="ion-padding-vertical">
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text
            color="primary"
            (click)="goToSignup()"
            class="link forgot-password"
            >New here? Create an account now!!</ion-text
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
